<template>
    <section class="py-20 lg:py-28 bg-background">
        <div class="container mx-auto px-4">
            <h2 class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.title_before }}
                <span v-if="content.title_accent" class="text-gradient-blue">{{ content.title_accent }}</span>
                {{ content.title_after }}
            </h2>
            <p v-if="content.subtitle" class="text-center text-muted-foreground mb-14 max-w-2xl mx-auto">
                {{ content.subtitle }}
            </p>

            <div v-if="content.image" class="max-w-5xl mx-auto">
                <img :src="content.image" :alt="content.image_alt || ''" class="w-full h-auto" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "GeographyBlock",
    props: { content: { type: Object, default: () => ({}) } },
};
</script>
